<template>

<div id="app" :class="stage.loc.customer">
	<PrivacyTips ref="privacyTips"></PrivacyTips>
	<Reminder ref="reminder"></Reminder>
	<div id="svg" class="dpN"></div>
	<WindowForAlert :title="announcement.title" :btnClose="false" :btnCancel="false" :size="'m'" ref="Window">
		<div v-html="announcement.content"></div>
		<template slot="btmBtn">
			<a v-if="announcement.buttonLink" :href="announcement.buttonLink" target="_blank" class="functionBtn dpIB sizeM-lh" @click="passAnnouncement">{{announcement.buttonName}}</a>
			<button v-else class="functionBtn" @click="passAnnouncement" type="button">{{announcement.buttonName}}</button>
		</template>
	</WindowForAlert>
	<router-view></router-view>
</div>
</template>

<script>
import {fillHeight, formModeChange, getCookie, setCookie, getUrlParam} from '@/util/lib.js';
import PrivacyTips from '@/view/frame/PrivacyTips.vue';
import Reminder from '@/view/frame/Reminder.vue';
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue';

import * as loginApi from '@/api/login';
import {apiAnnouncement, apiUpdateVersion} from '@/api/base.js';//, apiGetTimezoneOffset

export default {
	name: 'app',
	components: {WindowForAlert, PrivacyTips, Reminder},
	data () {
		return {
			stage,
			announcement: {}
		};
	},
	watch: {
		$route (to, from) {
			setTimeout(() => { // 切换路由后，延时获取公告
				if (from.path.includes('/login')) { this.getAnnouncement(); }
			}, 1000);
		}
	},
	created () {
		// if(!getCookie("language")) setCookie("language",stage.languageId);
		// $.ajax({
		// 	url:"static/image/ui.svg"+"?v="+stage.ver,
		// 	success:function(data){
		// 		svg=data;
		// 	}
		// });
		if (this.$route.query.dataBaseSelect || getUrlParam('dataBaseSelect')) {
			localStorage.setItem(`dataBase_${stage.loc.customer}`, stage.dataBase.urlBase);// 存储跳转过来的数据中心选择
			stage.dataBase.active = stage.dataBase.urlBase;
			stage.dataBase.activeChild = this.$route.query.dataBaseChild || '';
			localStorage.setItem(`dataBaseChildArea_${stage.loc.customer}`, stage.dataBase.activeChild);
		}

		// 百度统计代码
		if (stage.loc.statistic.baidu) {
			window._hmt = window._hmt || [];
			(function () {
				var hm = document.createElement('script');
				hm.src = stage.loc.statistic.baidu;
				var s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(hm, s);
			})();
		}
		// apiGetTimezoneOffset().then(success => {
		// 	success.forEach(function (li) {
		// 		stage.time.timezoneMap[li.code] = li;
		// 	});
		// });
	},
	methods: {
		getAnnouncement: function () { // 获取公告
			setTimeout(() => {
			   if (!stage.setting.loc.shieldWhiteList.Announcement) return;
				apiAnnouncement().then(success => {
					this.announcement = success;
					if (success.id) {
						if (!getCookie(`announcement${this.announcement.id}`)) {
							this.$refs.Window.show();
						}
					}
				});
			}, 0);
		},
		passAnnouncement: function () { // 记录公告cookie并关闭公告窗口
			setCookie(`announcement${this.announcement.id}`, 'pass');
			this.$refs.Window.hide();
		}
	},
	mounted () {
		stage.space = parseInt($('html').css('font-size'));
		let that = this;
		$('#svg').load(`${stage.loc.baseRouter}static/image/ui.svg?v=${stage.ver}`, function (data) { // 加载svg
			// trace(data)
			$('#svg').html(data);
			// $("#svg").append(data);

			$('#svg').find('symbol').not("[id='logo']").each(function () {
				$(this).find('[stroke]').each(function () {
					if ($(this).attr('stroke') == '#000') $(this).removeAttr('stroke');
				});
			});
		});

		// 处理第三方key
		// if(stage.loc.key[stage.loc.customer]){
		// 	stage.loc.key[stage.loc.customer]=stage.loc.key.SOLARMAN;
		// }

		// 公共操作

		// $(document).on("click",".window,.window .close,.window [winID]",function(e){//浮窗关闭动作
		// 	e.stopPropagation()
		// 	var $win;
		// 	if($(this).hasClass("window")&&!$(this).hasClass("window-lock"))	$win=$(this);//点击任意别的地方关闭本浮窗
		// 	else{
		// 		if($(this).attr("winID")!=undefined){
		// 			// $win=$("#"+$(this).attr("winID"));
		// 			// windowCtrl($("#"+$(this).attr("winID")));
		// 			if($(this).parents(".window-bg").length>0)	windowCtrl($(this).parents(".window-bg").first(),"false");//如果本浮窗是背景式，关闭本浮窗
		// 		}else $win=$(this).parents(".window").first();
		// 	}
		// 	windowCtrl($win,"false");
		// 	if($win&&$win.find(".guide").length>0) lockScroll(false);//解除锁定
		// 	// return false;
		// });
		$(document).on('click', '.window .body,.window .guide', function (e) {
			e.stopPropagation();
		});
		$(document, '[onclick]').on('click', 'a,button,label', function (e) { // 所有交互元素不冒泡
			e.stopPropagation();
			/*
			var evt = e ? e : window.event;
			if (evt.stopPropagation) {
			//W3C
			evt.stopPropagation();
			}
			else {
			//IE
			evt.cancelBubble = true;
			}
			*/
		});

		// $(document).on("click",".hasDropList-focus",function(){
		// 	trace(this)
		// 	$(this).focus();
		// });

		$(document).on('click', '.window-view li[mode] .title', function () { // 处理详情面板内的分类内容收起和展开以及编辑状态的控制
			let $root = $(this).parents('li').first();
			let mode = $root.attr('mode');
			switch (mode) {
			// case "edit":
			// 	break;
			case 'min':
				$root.attr('mode', 'def');
				$root.children('.content').stop().slideDown(500, 'easeInOutExpo', function () {
					$root.children('.content').css('height', '');// 不清空会残留高度影响内部的高度动画
				});
				break;
			case 'def':
				$root.attr('mode', 'min');
				$root.children('.content').stop().slideUp(500, 'easeInOutExpo');
				break;
			}
		});
		$(document).on('click', '.window-view li[mode] .modeCtrl button', function () { // 处理详情面板中编辑状态
			if ($(this).hasClass('save') == false) formModeChange(this);// 保存动作由组件自己触发
		});
		$(document).on('click', '.window-view li[mode] .content-edit button,.window-view li[mode] .content-edit a', function () { // 详情面板中编辑板块里按钮动作需要检查高度并修正
			let $btn = $(this);
			let $group = $btn.parents('.content').first().find('.changeGroup');
			setTimeout(function () {
				$group.css('height', $group.find('.content-edit').innerHeight());
			}, 500);
		});

		$(document).on('click', 'button', function () { // 解决点击按钮后，按回车依然可以触发事件
			if ($(this).is("[id*='help']") == false) { // 排除帮助功能按钮
				// let $button=$();trace($button,true)
				$('body').append(`<button id="fireFocus" style="position:absolute;opacity:0;">a</button>`);
				// let $this=$(this);
				// $(this).css("pointer-events","none");
				// setTimeout(function(){$this.css("pointer-events","");},10000);
				// $(this).parents("div").first().trigger("click");
				$('#fireFocus').focus();
				$('#fireFocus').remove();
			}
		});

		$(document).on('mouseenter', '.hasDropList-hover', function () { // 处理所有下拉位置修正
			if ($(this).hasClass('.select') == false) { // select组件有自己的修正
				if ($(this).parents('.window-alert').length > 0 && !$(this).addClass('fixedMode')) {
					$(this).addClass('fixedMode');
				}
				let $dropList = $(this).find('.dropList');
				// 上下修正
				let dropH = $dropList.innerHeight();
				let t = $(this).offset().top + $(this).find('.selectDisplay').innerHeight();
				if (t + dropH + stage.space > $(window).height()) {
					$(this).addClass('dropList-dropUp');
				} else {
					$(this).removeClass('dropList-dropUp');
				}
				// 左右修正
				let dropW = $dropList.innerWidth();
				let l = $(this).offset().left;
				if (l + dropW > $(window).width()) {
					// $dropList.css({left:"unset",right:0});
					$dropList.addClass('dropList-right').css({left: ''});
				} else {
					$dropList.removeClass('dropList-right');
				}
			}
		});

		$(window).resize(function () {
			that.$bus.$emit('monResize');
			that.$bus.$emit('resizePB');
			fillHeight(500);
			stage.space = parseInt($('html').css('font-size'));
		});
		apiUpdateVersion();
		setTimeout(() => {
			if (location.pathname.includes('/login')) {
				// 登录的公告触发由登录页控制
			} else {
				this.getAnnouncement();
			}
		}, 400);

		if (stage.loc.platformCode == 'SOLARMAN_BUSINESS') {
			if (!getCookie('privacyAgreementPrompt')) {
				var $this = this;
				var p = new Promise(function (resolve, reject) {
					let req = {
						system: stage.loc.customer,
						clientType: 'Web',
						businessType: stage.loc.platformCode
					};
					loginApi.getPrivacyPolicy(req).then(res => {
						if (!res) {
							if (stage.loc.platformCode == 'CSI_CLOUDPRO') {
								$this.$refs.reminder.show();
							} else {
								$this.$refs.privacyTips.show();
							}

							return false;
						} else {
							resolve();
							return true;
						}
					}, error => {
						!_.isEmpty(error) && this.$notify(error);
					});
				});
				return p;
			} else {
				let data = {
					'businessType': stage.loc.platformCode,
					'clientType': 'Web',
					'readStatus': 1,
					'system': stage.loc.customer
				};
				loginApi.setPrivacyPolicyYes(data).then(res => {
					return res;
				}, error => {
					!_.isEmpty(error) && this.$notify(error);
				});
				return true;
			}
		} else {
			return true;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/App.vue